import React, { useEffect, useState } from "react";
import NotFound from "../../../components/not-found/NotFound";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import Switch from "../../../components/Switch/Switch";
import ModalBox from "../../../components/modal/ModalBox";
import { capitalizeFirstLetter, dateFormat } from "../../../components/Form";
import {
  catchMessage,
  elseMessage,
  successMessage,
} from "../../../comman/Message";
import { getMeetupsListApi } from "../../../services/community";
import { changeMeetupsStatusApi } from "../../../services/meetups";
import { ViewIcon } from "../../../comman/action/ViewIcon";
import { PaginationShow } from "../../../comman/action/Pagination";

const Meetups = ({ id }) => {
  const [meetupsList, setMeetupsList] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  const [statusModal, setStatusModal] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [statusName, setStatusName] = useState("");
  const [statusId, setStatusId] = useState("");

  //*********Handel status********* */
  const statusUpdateHandler = (id, status, name) => {
    setStatusModal(true);
    setStatusId(id);
    setStatusValue(status);
    setStatusName(name);
  };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    setPage(event);
  };
  //--------------change-status-meetups-------------------------
  const changeStatus = async () => {
    try {
      let data = { status: !statusValue, id: statusId };
      const res = await changeMeetupsStatusApi(data);
      if (res.data.status === 200) {
        setStatusModal(false);
        getMeetupsList();
        successMessage(res);
      } else {
        elseMessage(res);
      }
    } catch (e) {
      catchMessage(e);
    }
  };
  //------------------listing-Api----------------------------------
  const getMeetupsList = async (activePage = page) => {
    try {
      setMeetupsList([]);
      const res = await getMeetupsListApi(id, { page: activePage });
      if (res?.data?.status === 200) {
        setMeetupsList(res?.data?.data?.meetupList || []); //remove 1
        setTotal(res?.data?.data?.total || 0);
      } else {
        elseMessage(res);
        setMeetupsList([]);
      }
    } catch (err) {
      catchMessage(err);
    }
  };

  useEffect(() => {
    getMeetupsList(page);
  }, [page, id]);
  return (
    <>
      <div className="content-table">
        <table>
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Event title</th>
              <th> Created by </th>
              <th>Create Date</th>
              <th>Event Date</th>
              <th>Status</th>
              <th>Type</th>
              <th className="text-center"> Action </th>
            </tr>
          </thead>
          <tbody>
            {meetupsList.length > 0 ? (
              meetupsList.map(
                (
                  {
                    categoryType,
                    createdAt,
                    createdBy,
                    endDate,
                    meetupStatus,
                    name,
                    startDate,
                    title,
                    _id,
                    status,
                  },
                  index
                ) => {
                  return (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{++index + (page - 1) * 10}</td>
                        <td>{title || "N/A"}</td>
                        <td>
                          {createdBy == "user" ? name : "Neptune" || "N/A"}
                        </td>
                        <td>{dateFormat(createdAt)}</td>
                        <td>{dateFormat(startDate)}</td>
                        <td>{capitalizeFirstLetter(meetupStatus) || "N/A"}</td>
                        <td>{categoryType || "N/A"}</td>
                        <td>
                          <div className="d-flex justify-content-center">
                            <Switch
                              checked={status}
                              onChange={() =>
                                statusUpdateHandler(_id, status, title)
                              }
                            />
                            <ViewIcon
                              to={`/meetups-management/view-details/${_id}`}
                            />
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                }
              )
            ) : (
              <NotFound
                cols={10}
                msg="No Meetups Found!"
                icon={<GroupsOutlinedIcon style={{ fontSize: 48 }} />}
              />
            )}
          </tbody>
        </table>
      </div>
      <PaginationShow
        total={total}
        activePage={page}
        handlePageChange={handlePageChange}
      />
      {/* --------change-meetups-status-modal----------- */}
      <ModalBox
        status={statusModal}
        onClose={() => setStatusModal(false)}
        title={`${statusValue ? "Block" : "Unblock"} Meetups`}
        description={
          <span>
            Do you want to {!statusValue ? "Unblock" : "block"}{" "}
            <strong>{statusName}</strong> ?
          </span>
        }
        action={changeStatus}
      />
    </>
  );
};

export default Meetups;
